import "../../design/loginStyle.css";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../api/API_SERVERS";
import { baseUrl } from "../helper/helperFunctions";
import { HiOutlineMail, HiOutlineLockClosed, HiMoon, HiSun } from "react-icons/hi";

let defaultObject = { username: '', password: '' }

export default function Login() {
    const [userInfo, setUserInfo] = useState(defaultObject);
    const [isDarkTheme, setIsDarkTheme] = useState(true);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem("AdminToken")) {
            setNotification({ type: "error", message: "Already logged in. Redirecting..." });
            setTimeout(() => window.location.replace(baseUrl), 1500);
            return;
        }

        try {
            const res = await axios.post(API_URL + "/api/admin/login", userInfo);
            const token = res.data.token;
            if (!token) { window.location.reload(); return; }

            localStorage.setItem("AdminToken", token);
            setNotification({ type: "success", message: "Welcome back! Access granted." });
            setTimeout(() => window.location.replace(baseUrl), 1000);
        } catch (err) {
            setNotification({ type: "error", message: "Invalid credentials. Please try again." });
            setTimeout(() => setNotification(null), 4000);
        } finally {
            setLoading(false);
        }
    };

    const changeHandler = (e) => {
        setUserInfo(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }

    return (
        <div className={`login-page ${isDarkTheme ? 'dark' : 'light'}`}>
            {/* Background Decorative Blobs */}
            <div className="blob-bg">
                <div className="blob blob-1"></div>
                <div className="blob blob-2"></div>
            </div>

            <div className="theme-toggle" onClick={() => setIsDarkTheme(!isDarkTheme)}>
                {isDarkTheme ? <HiSun size={24} /> : <HiMoon size={24} />}
            </div>

            <div className="login-card">
                <div className="login-header">
                    <h1>Teacher Hub</h1>
                    <p>Admin Control Panel</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label>Username</label>
                        <div className="input-wrapper">
                            <HiOutlineMail className="input-icon" />
                            <input
                                name='username'
                                type="text"
                                placeholder="Enter your username"
                                value={userInfo.username}
                                onChange={changeHandler}
                                required
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Password</label>
                        <div className="input-wrapper">
                            <HiOutlineLockClosed className="input-icon" />
                            <input
                                name='password'
                                type="password"
                                placeholder="••••••••"
                                value={userInfo.password}
                                onChange={changeHandler}
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className={`login-submit ${loading ? 'loading' : ''}`} disabled={loading}>
                        {loading ? 'Authenticating...' : 'Sign In'}
                    </button>
                </form>
            </div>

            {notification && (
                <div className={`notification-toast ${notification.type}`}>
                    {notification.message}
                </div>
            )}
        </div>
    );
};